import FilterCarModel from '../../../components/organism/FilterMenu/CarModel';
import FilterPriceRange from '../../../components/organism/FilterMenu/PriceRange';
import FilterSpecialOffer from '../../../components/organism/FilterMenu/SpecialOffer';

export default function generateFilterAccessories(
  minPrice,
  maxPrice,
  slideMin,
  slideMax,
  specialOffer,
  typeID,
  setTriggerFilter,
  pickUpOption,
  typeAccFilter,
  categoryFilter,
  carModelFilter,
  isPLPCategory
) {
  const dataFilter = [
    {
      title: 'Penawaran Khusus',
      content: specialOffer ? (
        <FilterSpecialOffer
          offerList={specialOffer}
          typeID={typeID}
          setTrigger={setTriggerFilter}
          isPLPCategory={isPLPCategory}
        />
      ) : null,
    },
    {
      title: 'Kisaran Harga',
      content: (
        <FilterPriceRange
          minPrice={minPrice}
          maxPrice={maxPrice}
          slideMin={slideMin}
          slideMax={slideMax}
          typeID={typeID}
        />
      ),
      dataTestId: null,
    },
    {
      title: 'Metode Pengiriman',
      content: pickUpOption ? (
        <FilterCarModel
          carModelList={pickUpOption.values}
          typeID={typeID}
          setTrigger={setTriggerFilter}
          isPLPCategory={isPLPCategory}
        />
      ) : null,
    },
    {
      ...(isPLPCategory || typeID === 'accessoriesWithAllFilter'
        ? {
            title: 'Model Mobil',
            content: carModelFilter ? (
              <FilterCarModel
                carModelList={carModelFilter.values}
                typeID={typeID}
                setTrigger={setTriggerFilter}
                isPLPCategory={isPLPCategory}
              />
            ) : null,
          }
        : {}),
    },
    {
      ...(!isPLPCategory || typeID === 'accessoriesWithAllFilter'
        ? {
            title: 'Kategori',
            content: categoryFilter ? (
              <FilterCarModel
                carModelList={categoryFilter.values}
                typeID={typeID}
                setTrigger={setTriggerFilter}
                isPLPCategory={isPLPCategory}
              />
            ) : null,
          }
        : {}),
    },
    {
      title: 'Tipe Aksesoris',
      content: typeAccFilter ? (
        <FilterCarModel
          carModelList={typeAccFilter.values}
          typeID={typeID}
          setTrigger={setTriggerFilter}
          isPLPCategory={isPLPCategory}
        />
      ) : null,
    },
  ];

  return dataFilter;
}
